import { Component, OnInit } from '@angular/core';
import { IonicSelectableComponent } from 'ionic-selectable'; //search en select
import * as firebase from 'firebase';
import { LoadingController } from '@ionic/angular';
import {ServiGetPostsService}from '../servi-get-posts.service'
import { ModalController } from '@ionic/angular';


//search en select
class Afe {
  public id: number;
  public name: string;

}

@Component({
  selector: 'app-modalselecciona-afe',
  templateUrl: './modalselecciona-afe.page.html',
  styleUrls: ['./modalselecciona-afe.page.scss'],
})
export class ModalseleccionaAfePage implements OnInit {

    //contenidos de seleccion multiple
    arraydeafes = [];
    cursordeafes;

      //search select AFE
  listadeafes: Afe[];
  objetodeafe: Afe;

  afe;

  constructor(public modalCtrl:ModalController, public loadingController: LoadingController, public serviGetPostsService:ServiGetPostsService ) {
    this.listadeafes = [];
   }

  ngOnInit() {
    this.cargaAfes()
  }




  cargaAfes(){

    this.serviGetPostsService.cargaitemsdeseleccion('afe',()=>{
      this.listadeafes=this.serviGetPostsService.listadeafes;
    })
  }


    //search select
    afeChange(event: {
      component: IonicSelectableComponent,
      value: any 
    }) {
      this.afe = event.value.codigo+" - "+event.value.proyecto;
      // this.proyecto = event.value.proyecto
      this.dismiss();

    }

    dismiss() {
      // using the injected ModalController this page
      // can "dismiss" itself and optionally pass back data
      this.modalCtrl.dismiss({
        'dismissed': true,
        afe: this.afe
      });
    }


    async presentLoading() {
      const loading = await this.loadingController.create({
        message: 'Cargando items...',
        // duration: 6000
      });
      await loading.present();
    
      const { role, data } = await loading.onDidDismiss();
    
      console.log('Loading dismissed!');
    }

}
